// extracted by mini-css-extract-plugin
export default {"visualBottomLinks":"VisualBottomLinks_visualBottomLinks__0z-cx","navBox":"VisualBottomLinks_navBox__QGoGZ"};